import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, fade} from '@material-ui/core/styles';
import {Button, Typography} from '@material-ui/core';
import {SectionHeader, TypedText} from 'components/molecules';
import {HeroShaped} from 'components/organisms';
import {isLightMode} from 'utils';
import {Image} from 'components/atoms';
import {showDemo} from 'common'

const heroImage = isLightMode()
   ? 'https://s3.amazonaws.com/content.rev-lock.com/images/site_hero.svg'
   : 'https://s3.amazonaws.com/content.rev-lock.com/images/site_hero.svg';

const useStyles = makeStyles(theme => ({
    fontWeight900: {
        fontWeight: 900,
        color: 'white'
    },
    leftSideContent: {
        '& .section-header__cta-container': {
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                '& .section-header__cta-item-wrapper': {
                    width: '100%',
                    '&:last-child': {
                        marginLeft: 0,
                        marginTop: theme.spacing(1),
                    },
                    '& .MuiButtonBase-root': {
                        width: '100%',
                    },
                },
            },
        }
    },
    heroShaped: {
        backgroundColor: fade(theme.palette.secondary.light, 1.0),
        '& .hero-shaped__image': {
            backgroundColor: theme.palette.alternate.main,
        },
        [theme.breakpoints.down('sm')]: {
            '& .hero-shaped__image': {
                position: 'relative',
            },
            '& .hero-shaped__wrapper': {
                flexDirection: 'column',
            },
        },
    },
    imageAnimation: {
        background: `url("${heroImage}")`,
        backgroundRepeat: 'repeat',
        backgroundAttachment: 'scroll',
        backgroundSize: '400px auto',
        animation: `$slideshow 50s linear infinite`,
        width: '600%',
        height: '600%',
        backgroundColor: theme.palette.alternate.dark,
        top: '-25%',
        left: '-100%',
        position: 'absolute',
        [theme.breakpoints.up('sm')]: {
            backgroundSize: '800px auto',
        }
    },
    '@keyframes slideshow': {
        '0%': {
            transform: 'rotate(-13deg) translateY(-25%)',
        },
        '100%': {
            transform: 'rotate(-13deg) translateY(-80%)',
        },
    },
    sup: {
        color: theme.palette.primary.main
    }
}));

const Hero = props => {
    const {className, onContact, ...rest} = props;
    const classes = useStyles();
    
    const title = (
       <Typography variant="h2" component="span" className={classes.fontWeight900}>
           Revenue recognition for SaaS<sup className={classes.sup}>+</sup> companies
           <br/>
           <TypedText
              component="span"
              variant="h4"
              color="secondary"
              className={classes.fontWeight900}
              typedProps={{
                  strings: [
                      'identify contracts',
                      'identify  perf obligations',
                      'determine transaction price',
                      'allocate price',
                      'recognize revenue',
                      'defer sales commissions',
                      'amortize sales commissions',
                      'and much more...',
                  ],
                  typeSpeed: 50,
                  loop: true,
              }}
           />
       </Typography>
    );
    
    const subtitle = 'Comply with ASC 606.  Eliminate Spreadsheets.  Get Timely and Accurate Revenue Results.';
    
    const demoButton = (
       <Button size="large" variant="outlined" color="primary" component="a" onClick={showDemo}>
           See Interactive Demo
       </Button>
    );
    
    const buyButton = (
       <Button
          size="large"
          variant="contained"
          color="primary"
          component="a"
          onClick={onContact}>
           Contact Us
       </Button>
    );
    
    const leftSideContent = (
       <SectionHeader
          title={title}
          subtitle={subtitle}
          align="left"
          titleProps={{
              variant: 'h2',
              color: 'textPrimary',
          }}
          subtitleProps={{
              color: 'textPrimary'
          }}
          ctaGroup={[demoButton, buyButton]}
          data-aos="fade-right"
          disableGutter
          className={classes.leftSideContent}
       />
    );
    return (
       <div className={className} {...rest}>
           <HeroShaped
              className={classes.heroShaped}
              leftSide={leftSideContent}
              rightSide={(
                 <Image
                    isObject={true}
                    src={heroImage}
                    width={548}
                    height={505}
                    style={{display: 'block', margin: 'auto'}}
                    alt="REVLOCK revenue automation"
                    className={classes.image}
                    data-aos="flip-left"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                 />
                 /*<div className={classes.imageAnimation} />*/
              )}
           />
       </div>
    );
};

Hero.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Hero;
